import * as React from 'react';
import {EventListenerProps} from './types';

const canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
const canUseEventListeners = canUseDOM && Boolean(window.addEventListener);

// TODO: add docs
export default class EventListener extends React.Component<EventListenerProps, {}> {
  public componentDidMount() {
    this._addEventListeners();
  }

  public getSnapshotBeforeUpdate() {
    this._removeEventListeners();
    return null;
  }

  public componentDidUpdate() {
    this._addEventListeners();
  }

  public componentWillUnmount() {
    this._removeEventListeners();
  }

  public render() {
    return null;
  }

  private _addEventListeners() {
    if (canUseEventListeners) {
      this.props.entries.forEach(({target, on, handler, options}) => {
        const node = this._getTargetNode(target);
        if (node) {
          node.addEventListener(on, handler, options);
        }
      });
    }
  }

  private _removeEventListeners() {
    if (canUseEventListeners) {
      this.props.entries.forEach(({target, on, handler, options}) => {
        const node = this._getTargetNode(target);
        if (node) {
          node.removeEventListener(on, handler, options);
        }
      });
    }
  }

  private _getTargetNode(target: string) {
    if (canUseDOM) {
      return window[target] || window.document.querySelector(target);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/EventListener/EventListener.tsx